export default {"scrollableRow":"_0xW-4","noSidePadding":"oLyV3"};